exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumbbar__breadcrumbbar {\r\n    max-width: 100%;\r\n    width: 100%;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/statics/BrandList.css
// module id = 1442
// module chunks = 0